import Splide from '@splidejs/splide';

jQuery(function ($) {
  function lockFocus(e) {
    const isTabPressed = e.key === "Tab" || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    e.preventDefault();

    if (focusableElements.length === 1) {
      focusableElements[0].focus();
    } else {
      if (e.shiftKey) {
        focusableElementsCurrentIndex--;
        if (focusableElementsCurrentIndex < 0) {
          focusableElementsCurrentIndex = focusableElements.length - 1;
        }
      } else {
        focusableElementsCurrentIndex++;
        if (focusableElementsCurrentIndex >= focusableElements.length) {
          focusableElementsCurrentIndex = 0;
        }
      }

      $.each(focusableElements, function () {
        $(this).removeClass("force-focus");
      });

      $(focusableElements[focusableElementsCurrentIndex]).focus();

      // Check if the current focusable element is either an <a> or a <div>
      if ($(focusableElements[focusableElementsCurrentIndex]).is("a, div")) {
        $(focusableElements[focusableElementsCurrentIndex]).addClass("force-focus");
      }


      const focusableElement = $(".force-focus")[0];

      if (focusableElement) {
        focusableElement.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }

  // HEARTS
  let clickedButtons = JSON.parse(localStorage.getItem("buttonHeart")) || [];

  $(".int-button").each(function () {
    let button = $(this);
    let nid = button.attr("data-nid");

    if (clickedButtons.includes(nid)) {
      button.addClass("clicked").prop("disabled", true);
      button.attr("aria-label", "hartje feedback gegeven");
      button.attr("aria-pressed", "true");
    }
  });

  $(document).on("click", ".int-button", function () {
    let button = $(this);
    let nid = button.attr("data-nid");
    let pageUrl = window.location.href;

    // Prevent click if nid is already in localStorage
    if (clickedButtons.includes(nid)) {
      console.log("Already clicked. Skipping AJAX request.");
      return;
    }

    let formValues = {
      button_id: nid,
      button_type: "heart",
      page_url: pageUrl,
    };

    // console.log("formmy", formValues);

    $.ajax({
      url: "/api/form/interactive",
      type: "POST",
      data: JSON.stringify(formValues),
      contentType: "application/json",
      success: function (response) {
        // console.log(response);

        // Add the nid to the clickedButtons array
        clickedButtons.push(nid);

        // Store the updated array in localStorage
        localStorage.setItem("buttonHeart", JSON.stringify(clickedButtons));

        // Update button UI
        button.addClass("clicked").prop("disabled", true);
        button.attr("aria-label", "hartje feedback gegeven");
        button.attr("aria-pressed", "true");
      },
      error: function (error) {
        console.error(error);
      },
    });
  });

  // THUMBS
  let clickedButtonsThumbs = JSON.parse(localStorage.getItem("buttonThumbs")) || [];

  $(document).on("click", ".thumbs-button", function (event) {
    let button = $(this);
    let nid = button.attr("data-nid");

    // Check which child element was clicked
    let target = $(event.target);
    let clickedClass = "";

    if (target.hasClass("thumbs-up")) {
      clickedClass = "thumbs-up";
    } else if (target.hasClass("thumbs-down")) {
      clickedClass = "thumbs-down";
    } else {
      return; // Do nothing if neither thumbs-up nor thumbs-down was clicked
    }

    // Prevent click if nid is already in localStorage
    let stored = clickedButtonsThumbs.find((item) => item.button_id === nid);
    if (stored) {
      console.log("Already clicked. Skipping AJAX request.");
      return;
    }

    console.log("Clicked:", clickedClass, "on button ID:", nid);
    let pageUrl = window.location.href;

    let formValues = {
      button_id: nid,
      // button_class: clickedClass,
      // button_type: "thumbs",
      button_type: clickedClass,
      page_url: pageUrl,
    };

    // console.log("formmy", formValues);

    $.ajax({
      url: "/api/form/interactive",
      type: "POST",
      data: JSON.stringify(formValues),
      contentType: "application/json",
      success: function (response) {
        // console.log(response);

        // Store the button ID and class in localStorage
        clickedButtonsThumbs.push(formValues);
        localStorage.setItem("buttonThumbs", JSON.stringify(clickedButtonsThumbs));

        // Add "clicked" class only to the clicked button
        target.addClass("clicked");
        button.find(".thumbs-up").prop("disabled", true);
        button.find(".thumbs-down").prop("disabled", true);

        // Update aria-labels depending on what was clicked
        if (clickedClass === "feedback-yes" || target.hasClass("thumbs-up")) {
          button.find(".thumbs-up")
            .attr("aria-label", "feedback duim omhoog geselecteerd")
            .attr("aria-pressed", "true");
          button.find(".thumbs-down")
            .attr("aria-label", "duim omlaag")
            .attr("aria-pressed", "false");
        } else if (clickedClass === "feedback-no" || target.hasClass("thumbs-down")) {
          button.find(".thumbs-down")
            .attr("aria-label", "feedback duim omlaag geselecteerd")
            .attr("aria-pressed", "true");
          button.find(".thumbs-up")
            .attr("aria-label", "feedback duim omhoog")
            .attr("aria-pressed", "false");
        }

      },
      error: function (error) {
        console.error(error);
      },
    });
  });

  $(".thumbs-button").each(function () {
    let button = $(this);
    let nid = button.attr("data-nid");

    let stored = clickedButtonsThumbs.find((item) => item.button_id === nid);
    if (stored) {
      button.find(`.${stored.button_type}`).addClass("clicked");
      button.find(".thumbs-up").prop("disabled", true);
      button.find(".thumbs-down").prop("disabled", true);

      if (stored.button_type === "thumbs-up") {
        button.find(".thumbs-up")
          .attr("aria-label", "feedbackduim omhoog geselecteerd")
          .attr("aria-pressed", "true");
        button.find(".thumbs-down")
          .attr("aria-label", "feedback duim omlaag")
          .attr("aria-pressed", "false");
      } else if (stored.button_type === "thumbs-down") {
        button.find(".thumbs-down")
          .attr("aria-label", "feedback duim omlaag geselecteerd")
          .attr("aria-pressed", "true");
        button.find(".thumbs-up")
          .attr("aria-label", "feedback duim omhoog")
          .attr("aria-pressed", "false");
      }
    }


  });


  // FEEDBACK


  $(".interested-interactive").on("click", function () {
    let button = $(this);
    let yesnoBox = button.siblings(".yesno");

    // Toggle the visibility of the yes/no options
    yesnoBox.toggleClass("hidden");

    // Toggle class on the button
    button.toggleClass("btn-interactive btn-interactive-click");
    button.attr("aria-expanded", "true");
  });


  let clickedButtonsFeedback = JSON.parse(localStorage.getItem("buttonFeedback")) || [];
  let feedbackModal = $(".feedback-modal");

  $(".feedback-button").each(function () {
    let button = $(this);
    let nid = button.attr("data-nid");

    let stored = clickedButtonsFeedback.find((item) => item.button_id === nid);
    if (stored) {
      button.find(`.${stored.button_type}`).addClass("clicked");

      button.find(".feedback-yes").prop("disabled", true).addClass("pointer-events-none");
      button.find(".feedback-no").prop("disabled", true).addClass("pointer-events-none");
    }
  });


  $(document).on("click", ".feedback-button", function (event) {
    let button = $(this);
    let nid = button.attr("data-nid");
    let target = $(event.target);
    let clickedClass = "";
    let pageUrl = window.location.href;
    let feedbackModal = button.siblings(".feedback-modal");
    let lastFocused = document.activeElement; // save trigger

    // Show modal when clicking feedback-yes or feedback-no
    if (target.hasClass("feedback-yes")) {
      clickedClass = "feedback-yes";
      feedbackModal.removeClass("hidden").attr("aria-hidden", "false");
    } else if (target.hasClass("feedback-no")) {
      clickedClass = "feedback-no";
      feedbackModal.removeClass("hidden").attr("aria-hidden", "false");
    } else {
      return;
    }

    // Prevent duplicate clicks
    let stored = clickedButtonsFeedback.find((item) => item.button_id === nid);
    if (stored) {
      console.log("Already clicked. Skipping AJAX request.");
      return;
    }

    console.log("Clicked:", clickedClass, "on button ID:", nid);

    target.addClass("clicked");
    button.find(".feedback-yes, .feedback-no")
      .prop("disabled", true)
      .addClass("pointer-events-none");

    // Default formValues
    let formValues = {
      button_id: nid,
      button_type: clickedClass,
      feedback: "",
      page_url: pageUrl,
    };

    // === focus trap logic ===
    const focusableEls = feedbackModal.find(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    feedbackModal.attr("tabindex", "-1").focus();

    function trapFocus(e) {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
          }
        } else {
          if (document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      } else if (e.key === "Escape") {
        closeModal();
      }
    }

    function closeModal() {
      feedbackModal.addClass("hidden").attr("aria-hidden", "true");
      $(document).off("keydown", trapFocus);
      if (lastFocused) $(lastFocused).focus();
    }

    $(document).on("keydown", trapFocus);

    feedbackModal.find(".submit-feedback, .close-feedback").on("click", function () {
      closeModal();
    });
    // === end focus trap ===

    $(".submit-feedback").on("click", function () {
      feedbackModal.addClass("hidden");
    });

    $(".close-feedback").on("click", function () {
      feedbackModal.addClass("hidden");
    });

    // === observer ===
    let observer = new MutationObserver(() => {
      if (feedbackModal.hasClass("hidden")) {
        let feedbackText = feedbackModal.find(".feedback-text").val().trim();

        let formValues = {
          button_id: nid,
          button_type: clickedClass,
          feedback: feedbackText ? feedbackText : "",
          page_url: pageUrl,
        };

        $.ajax({
          url: "/api/form/interactive",
          type: "POST",
          data: JSON.stringify(formValues),
          contentType: "application/json",
          success: function (response) {
            clickedButtonsFeedback.push(formValues);
            localStorage.setItem("buttonFeedback", JSON.stringify(clickedButtonsFeedback));
          },
          error: function (error) {
            console.error(error);
          },
        });
      }
    });

    observer.observe(feedbackModal[0], { attributes: true, attributeFilter: ["class"] });
  });

  $(".close-feedback").on("click", function () {
    feedbackModal.addClass("hidden");
  });


  // $.ajax({
  //   url: "/api/paragraphs/quote",
  //   type: "GET",
  //   contentType: "application/json",
  //   success: function (response) {
  //     console.log(response);
  //   },
  //   error: function (error) {
  //     console.error(error);
  //   },
  // });





  //---- Contact Form -----------------------------------------------
  if (document.getElementById("contactForm")) {
    const contactForm = document.getElementById("contactForm");
    const submitButton = document.getElementById("submitButton");
    const checkboxInput = document.getElementById("checkboxForm");

    // checkboxInput.addEventListener("keydown", function (event) {
    //   // Check if the key pressed is "Enter"
    //   if (event.key === "Enter") {
    //     checkboxInput.checked = !checkboxInput.checked; // Toggle the checkbox state
    //     event.preventDefault();
    //   }
    // });

    submitButton.addEventListener("click", (event) => {
      event.preventDefault();


      // const loaderElement = document.querySelector(".loader");
      const loaderElement = document.getElementById("loader-form");
      loaderElement.classList.add("active");

      const formData = new FormData(contactForm);
      const formValues = {};

      // console.log("formmy", formValues);

      formData.forEach((value, key) => {
        if (formValues[key]) {
          // If the key already exists, convert it into an array and push the value
          if (Array.isArray(formValues[key])) {
            formValues[key].push(value);
          } else {
            formValues[key] = [formValues[key], value];
          }
        } else {
          formValues[key] = value;
        }
      });

      // if (checkboxInput.checked) {
      // console.log("yes");
      $.ajax({
        url: "/api/form/contact/submit",
        type: "POST",
        data: JSON.stringify(formValues),
        contentType: "application/json",
        success: function (response) {
          // console.log(response);
          document.getElementById("responseMessageName").innerHTML = "";
          document.getElementById("responseMessageEmail").innerHTML = "";
          document.getElementById("responseMessageInfo").innerHTML = "";
          document.getElementById("responseMessageMsg").innerHTML = "";
          document.getElementById("responseSuccess").innerHTML = "";

          loaderElement.classList.remove("active");
          contactForm.reset();

          const modal = document.querySelector(".contact-success-modal");
          const closeButton = document.querySelector(
            ".contact-success-close"
          );

          function showDialog() {
            modal.classList.add("show-modal-contact");
            modal.classList.remove("invisible");
            modal.classList.remove("opacity-0");
            document.body.style.overflow = "hidden";

            // Get the texty-content inside modal
            const translateContent = modal.querySelector(".texty-content");
            if (translateContent && !translateContent.querySelector("h3")) {
              // If there's no <h3>, add it
              const heading = document.createElement("h3");
              heading.className = "pb-4 font-sharpgrotesk font-bold text-[32px]";
              heading.textContent = "Contactformulier verzonden";
              translateContent.prepend(heading);
            }

            $('.modal-content').attr("tabindex", "-1");

            let focusableElements = [];
            focusableElements.push(closeButton);
            focusableElements.push($(".modal-content"));

            let focusableElementsCurrentIndex = 0;
            $(document).on("keydown", lockFocus);
          }

          function closeDialog() {
            modal.classList.remove("show-modal-contact");
            modal.classList.add("invisible");
            modal.classList.add("opacity-0");
            document.body.style.overflow = "auto";

            let focusableElementsCurrentIndex = -1;
            $(document).off("keydown", lockFocus);
          }

          showDialog();

          // Add the event listener to the closeButton
          closeButton.addEventListener("click", closeDialog);
        },
        error: function (error) {
          console.error(error);

          // Parse the error response as JSON
          const errorResponse = JSON.parse(error.responseText);

          const responseSuccessElement = document.getElementById("responseSuccess");

          responseSuccessElement.setAttribute("tabindex", "-1");
          responseSuccessElement.setAttribute("role", "alert");

          // Display the error messages for each field
          if (errorResponse.errors.name) {
            document.getElementById("responseMessageName").innerHTML =
              '<div class="error" tabindex="0">' + errorResponse.errors.name[0] + "</div>";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="error" tabindex="0">' + "Vul alle velden juist in." + "</div>";
          } else {
            document.getElementById("responseMessageName").innerHTML = "";
          }

          if (errorResponse.errors.email) {
            document.getElementById("responseMessageEmail").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.email[0] +
              "</div>";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="error" tabindex="0">' + "Vul alle velden juist in." + "</div>";
          } else {
            document.getElementById("responseMessageEmail").innerHTML = "";
          }

          if (errorResponse.errors.message) {
            document.getElementById("responseMessageMsg").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.message[0] +
              "</div>";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="error" tabindex="0">' + "Vul alle velden juist in." + "</div>";
          } else {
            document.getElementById("responseMessageMsg").innerHTML = "";
          }

          if (errorResponse.errors.meer_informatie_voor) {
            document.getElementById("responseMessageInfo").innerHTML =
              '<div class="error" tabindex="0">' +
              errorResponse.errors.meer_informatie_voor[0] +
              "</div>";
            document.getElementById("responseSuccess").innerHTML =
              '<div class="error" tabindex="0">' + "Vul alle velden juist in." + "</div>";
          } else {
            document.getElementById("responseMessageInfo").innerHTML = "";
          }

          setTimeout(function () {
            if (responseSuccessElement) {
              responseSuccessElement.focus();
              responseSuccessElement.classList.add("force-focus");
            } else {
              // console.log('responseSuccessElement is not available for focus');
            }
          }, 100);  // Delay to allow DOM to update

          loaderElement.classList.remove("active");
        },
      });


      // console.log(formValues);
    });
  }



  //---- Photo Gallery carousel with Splide ----------------------------------------------------------------

  if ($('.gallery-carousel').length) {
    const galleryCarousel = new Splide('.gallery-carousel', {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      arrows: false,
      autoplay: false,
      speed: 1500,
      breakpoints: {
        768: {
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: false,
        },
      },
    });

    // Connect custom prev/next buttons
    $(".prev-btn-insta").on("click", function () {
      galleryCarousel.go('<');
    });

    $(".next-btn-insta").on("click", function () {
      galleryCarousel.go('>');
    });

    $(".prev-btn-insta").addClass("hidden");

    // Update button states on mount and move
    galleryCarousel.on('mounted move', function () {
      const currentIndex = galleryCarousel.index;
      const totalSlides = galleryCarousel.length;
      const perPage = window.innerWidth < 768 ? 1 : 3;
      const lastIndex = totalSlides - perPage;

      if (currentIndex === 0) {
        $(".prev-btn-insta").addClass("hidden");
      } else {
        $(".prev-btn-insta").removeClass("hidden");
      }

      if (currentIndex >= lastIndex) {
        $(".next-btn-insta").addClass("hidden");
      } else {
        $(".next-btn-insta").removeClass("hidden");
      }

      var $list = $('.splide__list');
      var $slides = $('.splide__slide');

      // Remove Splide's auto-added role=presentation on <ul>
      $list.removeAttr('role');

      // Fix roles for each slide
      $slides.each(function (index) {
        $(this)
          .attr('role', 'listitem');
      });

    });

    galleryCarousel.mount();
  }


  //---- Download Actueel file ----------------------------------------------------------------



  $(".downloadButton").on("click", function () {
    var docu_link = $(this).data("docu");
    // Extract the filename from the URL and decode it
    var fileName = decodeURIComponent(
      docu_link.substring(docu_link.lastIndexOf("/") + 1)
    );

    // Create a temporary link element
    var downloadLink = document.createElement("a");
    downloadLink.href = docu_link;

    // Set the download attribute with the decoded filename
    downloadLink.download = fileName;

    // Append the link to the document
    document.body.appendChild(downloadLink);

    // Trigger a click on the link to start the download
    downloadLink.click();

    // Remove the link from the document
    document.body.removeChild(downloadLink);
  });

  //---- Profile ----------------------------------------------------------------


  const myEvent = $("#myEvent");
  const myProfile = $("#myProfile");
  const divEvent = $("#panel-myEvent");
  const divProfile = $("#panel-myProfile");

  myEvent.on("click", function () {
    divEvent.fadeIn(300);
    divProfile.fadeOut(300);
    myEvent.addClass("button-active");
    myProfile.removeClass("button-active");
  });

  myProfile.on("click", function () {
    divEvent.fadeOut(300);
    divProfile.fadeIn(300);
    myEvent.removeClass("button-active");
    myProfile.addClass("button-active");
  });

  // check if the user has already registered for an event
  function getEventIDFromURL() {
    var urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get('eventID');
  }

  function isIdInArray(id, array) {
    // console.log(array.indexOf(id))
    return array.indexOf(id) !== -1;
  }


  // Check if an ID is present in the registeredEvent array
  function checkIdInRegisteredEvent(id) {
    var registeredEvents = JSON.parse(localStorage.getItem('registeredEvent')) || [];
    return isIdInArray(id, registeredEvents);
  }

  const loginToken = localStorage.getItem("login-token");
  const pastEvent = localStorage.getItem("past-event");

  if (checkIdInRegisteredEvent(parseInt(getEventIDFromURL())) && loginToken !== null) {
    $('#register-btn').hide();
    $('#event-registered').css('display', 'block');
  }

  if (loginToken === null && pastEvent === null) {
    // console.log('user is not logged in, add trigger login');
    $('#register-btn').hide();
    $('#login-btn').css('display', 'block');
  }


  // ------  RESULT PAGE ---------------


  // show details
  $(document).on("click keydown", ".result-more", function (event) {
    if (event.type === "click" || event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      $(this).prevAll(".details:first").stop().slideToggle();
    }
  });


  // filter and load more

  // Automatically sort by "Most Popular" on page load
  let defaultSort = "total";
  sortItems(defaultSort);
  updateDropdownText(defaultSort);

  $("#sortDropdownBtn").on("click", function (event) {
    event.stopPropagation();
    $("#sortMenu").toggle();
  });

  $(".sort-option").on("click", function (event) {
    event.stopPropagation();

    let selectedSort = $(this).data("sort");
    sortItems(selectedSort);
    updateDropdownText(selectedSort);

    $("#sortMenu").hide();
  });

  // Hide dropdown when clicking outside
  $(document).on("click", function (event) {
    if (!$(event.target).closest("#sortDropdownBtn, #sortMenu").length) {
      $("#sortMenu").hide();
    }
  });

  // Sorting function
  function sortItems(sortType) {
    let $items = $(".contentResult");

    if ($items.length === 0) {
      return;
    }

    let sortedItems = $items.get().sort(function (a, b) {
      let aTotal = parseInt($(a).data("total"), 10);
      let bTotal = parseInt($(b).data("total"), 10);
      let aDate = new Date($(a).data("date"));
      let bDate = new Date($(b).data("date"));

      if (sortType === "total") {
        return bTotal - aTotal;
      } else if (sortType === "latest") {
        return bDate - aDate;
      } else if (sortType === "oldest") {
        return aDate - bDate;
      }
    });

    $("#interactive-list").html(sortedItems);
    applyLoadMore();
  }

  function updateDropdownText(sortType) {
    let dropdownOptions = {
      "total": "Meest populair",
      "latest": "Nieuw naar oud",
      "oldest": "Oud naar nieuw"
    };

    $("#sortDropdownBtn").text(dropdownOptions[sortType]);

    $(".sort-option").show();
    $(".sort-option[data-sort='" + sortType + "']").hide();
  }

  // Load More function
  function applyLoadMore() {
    $(".contentResult").hide();
    $(".contentResult").slice(0, 4).show();

    if ($(".contentResult:hidden").length === 0) {
      $("#load-more-result").addClass("hidden");
    } else {
      $("#load-more-result").removeClass("hidden");
    }
  }

  $("#load-more-result").on("click", function (e) {
    e.preventDefault();
    $(".contentResult:hidden").slice(0, 4).fadeIn(500);

    if ($(".contentResult:hidden").length === 0) {
      $("#load-more-result").addClass("hidden");
    }
  });

  applyLoadMore();


  // ------  YOUTUBE LAZY LOADING ---------------

  let hasScrolled = false;
  let observerActive = false;

  function observeLastVisibleItem() {
    const visibleItems = $('.youtube-item:visible');
    const hiddenItems = $('.youtube-item:hidden');

    if (hiddenItems.length === 0) {
      observerActive = false;
      return;
    }

    const lastVisibleItem = visibleItems.last()[0];

    if (!lastVisibleItem) {
      return;
    }

    observerActive = true;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!hasScrolled) {
          return;
        }

        if (entry.isIntersecting) {
          const currentHidden = $('.youtube-item:hidden');
          currentHidden.slice(0, 4).fadeIn(500);

          observer.disconnect();
          observerActive = false;
          setTimeout(observeLastVisibleItem, 800);
        }
      });
    }, {
      rootMargin: '200px',
      threshold: 0.5
    });

    observer.observe(lastVisibleItem);
  }

  if ($('.youtube-item').length > 0) {
    observeLastVisibleItem();

    let scrollTimeout;
    $(window).on('scroll', function () {
      if (!hasScrolled) {
        hasScrolled = true;
      }

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        if (!observerActive && $('.youtube-item:hidden').length > 0) {
          observeLastVisibleItem();
        }
      }, 100);
    });
  }

  // ------  YOUTUBE MODAL PLAYER ---------------

  function openYouTubeModal(elm) {
    const videoId = elm.data('video-id');

    if (videoId === null || videoId === undefined || videoId === '') {
      return;
    }

    const videoTitle = elm.data('video-title');
    const type = elm.data('type');
    const modal = $('#youtube-modal');
    const playerContainer = $('#youtube-player-container');
    const iframe = $('<iframe>', {
      src: `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`,
      frameborder: '0',
      allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
      allowfullscreen: true,
      title: videoTitle || 'YouTube video player',
      class: 'absolute top-0 left-0 w-full h-full'
    });
    modal.attr('aria-labelledby', `yt-${videoId}`);

    modal.find('.video-wrapper').removeClass('youtube-video youtube-short').addClass(type === 'short' ? 'youtube-short' : 'youtube-video');

    playerContainer.html(iframe);
    modal.removeClass('hidden').attr('aria-hidden', 'false');
    $('body').css('overflow', 'hidden');
    setTimeout(() => $('#close-youtube-modal').focus(), 100);
  }

  function closeYouTubeModal() {
    const modal = $('#youtube-modal');
    const playerContainer = $('#youtube-player-container');

    playerContainer.empty();
    modal.addClass('hidden').attr('aria-hidden', 'true');
    $('body').css('overflow', '');
  }

  $(document).on('click', '.youtube-trigger', function (e) {
    e.preventDefault();
    openYouTubeModal($(this));
  });

  $(document).on('keydown', '.youtube-trigger', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openYouTubeModal($(this));
    }
  });

  $('#close-youtube-modal').on('click', closeYouTubeModal);

  $('#youtube-modal').on('click', function (e) {
    if (e.target === this) closeYouTubeModal();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && !$('#youtube-modal').hasClass('hidden')) {
      closeYouTubeModal();
    }
  });


  // ------  end YOUTUBE MODAL PLAYER ---------------


  function openVideoModal(videoUrl) {
    const video = $('#modal-video')[0];

    $('#modal-video-source').attr('src', videoUrl);
    video.load();

    $('#video-modal').removeClass('hidden').addClass('flex');
    $('body').addClass('overflow-hidden');

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(function (error) {
        console.log('Autoplay prevented:', error);
      });
    }
  }

  function closeVideoModal() {
    const video = $('#modal-video')[0];
    video.pause();
    $('#modal-video-source').attr('src', '');
    video.load();
    $('#video-modal').addClass('hidden').removeClass('flex');
    $('body').removeClass('overflow-hidden');
  }

  $(document).on('click', '.video-trigger', function () {
    const videoUrl = $(this).data('video-url');
    if (videoUrl) {
      openVideoModal(videoUrl);
    }
  });

  $(document).on('click', '#close-video-modal', function () {
    closeVideoModal();
  });

  $(document).on('click', '#video-modal', function (e) {
    if (e.target === this) {
      closeVideoModal();
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && !$('#video-modal').hasClass('hidden')) {
      closeVideoModal();
    }
  });




});  //close jquery
